import { render, staticRenderFns } from "./ThingsToNote1.vue?vue&type=template&id=5bbe7158&"
import script from "./ThingsToNote1.vue?vue&type=script&lang=js&"
export * from "./ThingsToNote1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports